(function () {
  const ROOT_SELECTOR = '[data-gaia-steps-root]';
  const CONTENT_SELECTOR = '.gaia-steps__content.rte';

  function syncContentHeights(root) {
    const contents = root.querySelectorAll(CONTENT_SELECTOR);
    if (contents.length < 2) return;

    contents.forEach((el) => {
      el.style.height = 'auto';
    });

    let maxHeight = 0;
    contents.forEach((el) => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    if (maxHeight <= 0) return;

    contents.forEach((el) => {
      el.style.height = `${maxHeight}px`;
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.gaiaStepsInit === 'true') return;
    root.dataset.gaiaStepsInit = 'true';

    const runSync = () => syncContentHeights(root);

    runSync();

    let resizeTimer;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(runSync, 150);
    };

    window.addEventListener('resize', onResize);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => runSync());
      observer.observe(root);
      root._gaiaStepsResizeObserver = observer;
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(runSync).catch(() => {});
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  function onSectionLoad(event) {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (!root) return;

    delete root.dataset.gaiaStepsInit;
    if (root._gaiaStepsResizeObserver) {
      root._gaiaStepsResizeObserver.disconnect();
      delete root._gaiaStepsResizeObserver;
    }

    initRoot(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
